import React, { useState } from "react";
import WorkspaceCollapsible from "src/components/Common/WorkspaceCollapsible";
import AddCardModal from "src/components/Stripe/AddCardModal";

const GetPaymentDetailsPage = () => {
  const [addCardDialog, setAddCardDialog] = useState(false);

  const handleAddCardClick = () => {
    setAddCardDialog(true);
  };

  return (
    <>
      <div className="min-h-screen bg-background-default flex flex-col">
        {/* Main Content */}
        <div className="flex-1 flex items-center justify-center p-8">
          <div className="max-w-md w-full bg-surface-default rounded-lg shadow-lg p-8 text-center">
            {/* Workspace Switcher - At the top */}
            <div className="w-full p-2 bg-surface-default shadow-md">
              <WorkspaceCollapsible
                collapsed={false}
                allowAddWorkspace={false}
              />
            </div>
            <div className="mb-6">
              <svg
                className="w-16 h-16 mx-auto text-alert-error"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                />
              </svg>
            </div>

            <h2 className="text-2xl font-bold text-textIcon-highEmp mb-4">
              Card Details Required
            </h2>

            <p className="text-textIcon-medEmp mb-6">
              You need to setup a payment method to access this workspace.
            </p>

            <button
              className="w-full bg-primary-default hover:bg-primary-light text-textIcon-onAccentHighEmp font-medium py-3 px-4 rounded-lg transition-colors duration-200"
              onClick={handleAddCardClick}
            >
              Add Card Details
            </button>

            <p className="text-sm text-textIcon-disable mt-4">
              Need help? Contact support at support@100ms.live
            </p>
          </div>
        </div>
      </div>

      <AddCardModal
        open={addCardDialog}
        setOpen={setAddCardDialog}
        redirectUrl="dashboard"
      />
    </>
  );
};

export default GetPaymentDetailsPage;
